/**
 * Formats a form name into a URL-friendly string
 * @param {string} formName - The name of the form to format
 * @returns {string} - The URL path for the form
 */
export const formatFormUrl = (formName) => {
  // First remove parentheses and their contents
  const nameWithoutParentheses = formName.replace(/\s*\([^)]*\)\s*/g, ' ').trim();
  // Then convert to URL-friendly format (lowercase, replace spaces with hyphens)
  return `/forms/${nameWithoutParentheses.toLowerCase().replace(/[\s,\.]/g, '-').replace(/--+/g, '-')}`;
}; 